export enum E_SOURCE_TYPE {
  JSON = 'json',
  DICTIONARY = 'dictionary',
  ARRAY_OF_DICTIONARIES = 'arrayOfDictionaries',
};

export type TSourceData = {
  [E_SOURCE_TYPE.JSON]: string;
  [E_SOURCE_TYPE.DICTIONARY]: Record<string, any>;
  [E_SOURCE_TYPE.ARRAY_OF_DICTIONARIES]: Record<string, any>[];
};

export type TSourceDataResult = {
  [E_SOURCE_TYPE.JSON]: Record<string, any> | Record<string, any>[];
  [E_SOURCE_TYPE.DICTIONARY]: Record<string, any>;
  [E_SOURCE_TYPE.ARRAY_OF_DICTIONARIES]: Record<string, any>[];
}

export type TSoftTable = Record<string, any>[];

export type TOriginalSource = 'array' | 'object' | undefined | null;